"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _QuestionCircleOutlined = _interopRequireDefault(require("@foxui/ui-icons-svg/lib/asn/QuestionCircleOutlined"));
var _AntdIcon = _interopRequireDefault(require("../components/AntdIcon"));
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var QuestionCircleOutlined = function QuestionCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
    ref: ref,
    icon: _QuestionCircleOutlined.default
  }));
};

/**![question-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMjYgOC4wMkEyIDIgMCAwMTEzLjkyIDEwYzAgLjQ3LS4zNy45Ni0xLjA1IDEuNDJhNi4wNSA2LjA1IDAgMDEtMS4yNS42M2gtLjAyYTEgMSAwIDAwLjY0IDEuOWwtLjMyLS45NS4zMi45NWguMDFsLjA0LS4wMmE1LjQxIDUuNDEgMCAwMC41LS4yYy4zMi0uMTQuNzUtLjM2IDEuMTgtLjY1LjgxLS41NCAxLjk1LTEuNTUgMS45NS0zLjA4YTQgNCAwIDAwLTcuNzctMS4zMyAxIDEgMCAxMDEuODguNjYgMiAyIDAgMDEyLjIzLTEuM3pNMTEgMTdhMSAxIDAgMDExLTFoLjAxYTEgMSAwIDExMCAySDEyYTEgMSAwIDAxLTEtMXoiIC8+PHBhdGggZD0iTTEgMTJhMTEgMTEgMCAxMTIyIDAgMTEgMTEgMCAwMS0yMiAwem0xMS05YTkgOSAwIDEwMCAxOCA5IDkgMCAwMDAtMTh6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/React.forwardRef(QuestionCircleOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'QuestionCircleOutlined';
}
var _default = exports.default = RefIcon;